/* Price Cart UK – Product Page Enhancements v5 */
(function() {
  'use strict';

  function initStickyBar() {
    var form = document.querySelector('[data-section-type="product"] .product-form');
    var addBtn = document.querySelector('.product-form__add-button');
    if (!addBtn) addBtn = document.querySelector('.product-form .button--primary');
    if (!form || !addBtn) return;

    var title = document.querySelector('.product-meta__title');
    var price = document.querySelector('.product-meta .price__number');

    // Image
    var imgSrc = '';
    var imgEl = document.querySelector('.product-gallery__image');
    if (imgEl) {
      var raw = imgEl.getAttribute('data-src') || imgEl.getAttribute('src') || '';
      imgSrc = raw.replace(/{width}/g, '100').replace('_{width}x', '_100x');
      if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
    }
    if (!imgSrc) {
      var thumbEl = document.querySelector('.product-gallery__thumbnail img');
      if (thumbEl) {
        imgSrc = thumbEl.getAttribute('data-src') || thumbEl.getAttribute('src') || '';
        if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
      }
    }

    // Build variant selector HTML from existing selects
    var variantHtml = '';
    var origSelects = form.querySelectorAll('.product-form__single-selector');
    if (origSelects.length > 0) {
      variantHtml = '<div class="pc-sticky-bar__variants">';
      origSelects.forEach(function(sel, idx) {
        var label = '';
        var labelEl = sel.closest('.product-form__option');
        if (labelEl) {
          var labelName = labelEl.querySelector('.product-form__option-name');
          if (labelName) {
            // Extract just the option name (before the colon/span)
            label = labelName.childNodes[0] ? labelName.childNodes[0].textContent.trim().replace(/:$/, '') : '';
          }
        }
        variantHtml += '<select class="pc-sticky-bar__select" data-sticky-idx="' + idx + '" aria-label="' + label + '">';
        for (var i = 0; i < sel.options.length; i++) {
          var opt = sel.options[i];
          variantHtml += '<option value="' + opt.value + '"' + (opt.selected ? ' selected' : '') + '>' + opt.textContent + '</option>';
        }
        variantHtml += '</select>';
      });
      variantHtml += '</div>';
    }

    var bar = document.createElement('div');
    bar.className = 'pc-sticky-bar';

    var html = '<div class="pc-sticky-bar__inner">';
    html += '<div class="pc-sticky-bar__info">';
    if (imgSrc) html += '<img class="pc-sticky-bar__image" src="' + imgSrc + '" alt="">';
    html += '<span class="pc-sticky-bar__title">' + (title ? title.textContent.trim() : '') + '</span>';
    html += '</div>';
    html += variantHtml;
    html += '<span class="pc-sticky-bar__price">' + (price ? price.textContent.trim() : '') + '</span>';
    html += '<button class="pc-sticky-bar__btn" type="button">Add to Cart</button>';
    html += '</div>';
    bar.innerHTML = html;

    document.body.appendChild(bar);

    // Sync sticky selects → original selects (bidirectional)
    var stickySelects = bar.querySelectorAll('.pc-sticky-bar__select');
    stickySelects.forEach(function(stickySelect, idx) {
      var origSelect = origSelects[idx];
      if (!origSelect) return;

      // Sticky → Original
      stickySelect.addEventListener('change', function() {
        origSelect.value = this.value;
        origSelect.dispatchEvent(new Event('change', { bubbles: true }));
        // Update price in sticky bar after variant change
        setTimeout(function() {
          var newPrice = document.querySelector('.product-meta .price__number');
          var stickyPrice = bar.querySelector('.pc-sticky-bar__price');
          if (newPrice && stickyPrice) stickyPrice.textContent = newPrice.textContent.trim();
        }, 300);
      });

      // Original → Sticky (observe changes)
      var mo = new MutationObserver(function() {
        if (stickySelect.value !== origSelect.value) {
          stickySelect.value = origSelect.value;
        }
      });
      mo.observe(origSelect, { attributes: true, childList: true, subtree: true });

      // Also listen for change events on original
      origSelect.addEventListener('change', function() {
        stickySelect.value = origSelect.value;
      });
    });

    // Add to cart
    bar.querySelector('.pc-sticky-bar__btn').addEventListener('click', function() {
      addBtn.click();
      this.textContent = '\u2713 Added!';
      var self = this;
      setTimeout(function() { self.textContent = 'Add to Cart'; }, 2000);
    });

    // Show/hide
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }, { threshold: 0 });
      observer.observe(addBtn);
    } else {
      window.addEventListener('scroll', function() {
        var rect = addBtn.getBoundingClientRect();
        if (rect.bottom < 0) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
